import React, { useEffect, useState } from "react";
import {
  ColorPickerCaption,
  ColorPickerContainer,
  ColorPickerInput,
  ColorPickerPreview,
  ColorPickersContainer,
  ColorPickerText,
  ColorPickerTextContainer,
  Container,
  Label,
} from "./styles";

export default function ColorPickers({
  name,
  label,
  colors = [],
  onChangeColors = () => null,
  ...props
}) {
  const [newColors, setNewColors] = useState(colors);

  useEffect(() => {
    // Somente para atrasar um pouquinho a atualização dos dados do forms
    const timer = setTimeout(() => {
      onChangeColors(newColors)
    }, 300);

    return () => clearTimeout(timer);
  }, [newColors])

  const handleChangeColor = (colorIndex, colorValue) => {
    setNewColors(prev => {
      const newColors = [...prev];

      newColors[colorIndex] = {
        ...newColors[colorIndex],
        value: colorValue,
      };

      return newColors;
    });
  };

  return (
    <Container>
      <Label htmlFor={name}>{label}</Label>
      <ColorPickersContainer>
        {colors.map((color, index) => {
          return (
            <ColorPickerContainer key={index}>
              <ColorPickerPreview colorValue={color.value} />
              <ColorPickerTextContainer>
                <ColorPickerText>{color.value}</ColorPickerText>
                <ColorPickerCaption>{color.name}</ColorPickerCaption>
              </ColorPickerTextContainer>
              <ColorPickerInput
                value={color.value}
                name={name}
                onChange={(e) => handleChangeColor(index, e.target.value)}
              />
            </ColorPickerContainer>
          );
        })}
      </ColorPickersContainer>
    </Container>
  );
}
